import "./App.css";
import { Box, Flex, Text } from "@chakra-ui/layout";
import Logo from "./assets/LOGO.png";
import Twitter from "./assets/twitter.png";
import Ig from "./assets/ig.png";
import {
  Image,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import Hero from "./assets/hero.png";
import { useEffect, useState } from "react";
import {
  addDoc,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore/lite";
import { db } from "./firebase";
import Locked from "./assets/locked.png";
import { IoMdLock, IoMdUnlock } from "react-icons/io";
import Book from "./components/Book";
import { getAnalytics, logEvent } from "firebase/analytics";

function App() {
  const [hasAccess, setHasAccess] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [viewBook, setViewBook] = useState(false);

  const { isOpen, onOpen, onClose } = useDisclosure();

  const analytics = getAnalytics();
  logEvent(analytics, "page_view");

  useEffect(() => {
    const disableRightClick = (e) => {
      e.preventDefault();
    };

    document.addEventListener("contextmenu", disableRightClick);

    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
    };
  }, []);

  const signup = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const usersRef = collection(db, "users");
      const querySnapshot = await getDocs(
        query(usersRef, where("email", "==", email))
      );

      if (!querySnapshot.empty) {
        // Email already exists, handle the error or provide appropriate feedback to the user
        // console.error("Email already exists");
        setHasAccess(true);
        setViewBook(true);
        onClose();
        localStorage.setItem("hasAccess", true);
        return;
      }

      const docRef = await addDoc(usersRef, {
        email: email,
        waitlisted: true,
      });
      setHasAccess(true);
      localStorage.setItem("hasAccess", true);
      console.log("Document added with ID:", docRef.id);
    } catch (error) {
      setError(`mething went wrong: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const checkAccess = localStorage.getItem("hasAccess");

    if (checkAccess === "true") {
      setHasAccess(true);
    }
  }, []);

  return (
    <Box
      bg={"#333"}
      pt={["10px", "10px", "15px", "20px"]}
      px={["10px", "10px", "15px", "20px"]}
    >
      <Modal
        closeOnOverlayClick={false}
        isCentered
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          fontFamily="nunito"
          margin={[1.5]}
          padding={[2]}
          border="1px solid #373D31"
          borderRadius="10px"
          maxW="530px"
          bg="#D9D9D9"
        >
          <ModalHeader
            // textAlign="center"
            color="#EB1C47"
            fontSize="1.6rem"
            fontWeight="700"
          >
            Sign up now
          </ModalHeader>
          <ModalCloseButton _focus={{ boxShadow: "none" }} color="#000" />
          <ModalBody color="#fff">
            <Input
              type={"email"}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              focusBorderColor={"#555"}
              _focus={{ boxShadow: "none" }}
              _hover={{ boxShadow: "none" }}
              border="1px solid #555"
              borderColor={"#555"}
              borderRadius={"10px"}
              placeholder={"Email"}
              bg="#D9D9D9"
              padding={"1.7rem 1.5rem"}
              _placeholder={{ fontSize: ".9rem" }}
              color={"#000"}
            />
            <Box
              cursor={"pointer"}
              borderRadius={"10px"}
              p={"15px"}
              bg={"#EB1C47"}
              // maxW={["90%", "90%", "80%", "40%"]}
              mt={"20px"}
              onClick={signup}
            >
              <Text textAlign={"center"} color={"#fff"} fontFamily={"nunito"}>
                {" "}
                {loading ? "loading..." : "Submit"}
              </Text>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
      <Flex
        borderRadius={"40px"}
        bg={"#4E4E4E"}
        py={"15px"}
        px={"25px"}
        justifyContent={["space-between"]}
        alignItems={"center"}
        w={"100%"}
      >
        <Box>
          <Image src={Logo} w={["120px", "120px", "120px", "150px"]} />
        </Box>
        <Flex w={["60px", "60px", "80px"]} justifyContent={"space-between"}>
          <a
            href="https://twitter.com/symphoniistudio?t=j_itcM7EYCVRbTm7yRwWXQ&s=09"
            target="_blank"
          >
            <Image src={Twitter} w={["20px", "20px", "20px", "25px"]} />
          </a>
          <a
            href="https://instagram.com/symphoniistudios?igshid=NTc4MTIwNjQ2YQ=="
            target="_blank"
          >
            <Image src={Ig} w={["20px", "20px", "20px", "25px"]} />
          </a>
        </Flex>
      </Flex>
      {hasAccess && viewBook ? (
        <Book setViewBook={setViewBook} />
      ) : (
        <>
          <Flex
            alignItems={"center"}
            flexDirection={["column", "column", "column", "row"]}
          >
            <Box flex={".6"} mt={"60px"}>
              <Image src={Hero} />
            </Box>
            <Flex
              justifyContent={"flex-start"}
              flexDirection={"column"}
              alignItems={["center", "center", "center", "flex-start"]}
              flex={".5"}
              pl={["0", "0", "0", "25px"]}
            >
              <Text
                color={"#fff"}
                fontFamily={"nunito"}
                fontSize={["25px", "25px", "30px", "35px"]}
              >
                Mmanwu: spirit among us
              </Text>
              <Text
                my={"15px"}
                maxW={["90%", "90%", "80%", "65%"]}
                color={"#fff"}
                fontSize={"15px"}
                fontFamily={"nunito"}
                textAlign={["center", "center", "center", "left"]}
              >
                The secret seal is accidentally broken unleashing the fury of
                demons on earth. Now a young business man must rise to the call
                of the spirits amongst us.
              </Text>
              {!hasAccess ? (
                <Box
                  cursor={"pointer"}
                  borderRadius={"40px"}
                  p={"15px"}
                  bg={"#EB1C47"}
                  w={["90%", "90%", "80%", "60%"]}
                  mt={"20px"}
                  onClick={() => onOpen()}
                >
                  <Text
                    textAlign={"center"}
                    color={"#fff"}
                    fontFamily={"nunito"}
                  >
                    Access Book
                  </Text>
                </Box>
              ) : (
                <Box
                  cursor={"pointer"}
                  borderRadius={"40px"}
                  p={"15px"}
                  border={"1px solid #EB1C47"}
                  w={["90%", "90%", "80%", "60%"]}
                  mt={"20px"}
                  onClick={() => setViewBook(true)}
                >
                  <Text
                    textAlign={"center"}
                    color={"#EB1C47"}
                    fontFamily={"nunito"}
                  >
                    Read Now
                  </Text>
                </Box>
              )}
            </Flex>
          </Flex>

          <Box mt={"50px"}>
            {!hasAccess ? (
              <Box>
                <Text
                  fontFamily={"nunito"}
                  color={"#fff"}
                  textAlign={"center"}
                  fontSize={["14px", "14px", "16px", "16px"]}
                  px={"20px"}
                >
                  Get ready to embark on an incredible reading journey. Sign up
                  and start exploring the book now!
                </Text>
                <Box mt={"25px"} position={"relative"}>
                  <hr />
                  <Box opacity={".5"}>
                    <Flex
                      justifyContent={"center"}
                      position={"absolute"}
                      top={"20px"}
                      left={"48%"}
                    >
                      <IoMdLock fontSize={"40px"} color={"#D1D1D1"} />
                    </Flex>
                    <Box mt={"35px"}>
                      <Image src={Locked} height={"220px"} w={"100%"} />
                    </Box>
                  </Box>
                </Box>
              </Box>
            ) : (
              <Box onClick={() => setViewBook(true)} position={"relative"}>
                <Text
                  fontFamily={"nunito"}
                  color={"#fff"}
                  textAlign={"center"}
                  fontSize={["14px", "14px", "16px", "16px"]}
                  px={"20px"}
                >
                  Embark on an incredible reading journey. Start exploring the
                  book now!"
                </Text>
                <Box mt={"25px"} position={"relative"}>
                  <hr />
                  <Box opacity={".7"}>
                    <Flex
                      justifyContent={"center"}
                      position={"absolute"}
                      top={"20px"}
                      left={["45%", "45%", "48%"]}
                      flexDirection={"column"}
                    >
                      <IoMdUnlock fontSize={"40px"} color={"#D1D1D1"} />
                    </Flex>

                    <Box mt={"35px"}>
                      <Image src={Locked} height={"220px"} w={"100%"} />
                    </Box>
                  </Box>
                </Box>
                <Box
                  position={"absolute"}
                  top={"120px"}
                  left={["5%", "5%", "28%"]}
                  cursor={"pointer"}
                  borderRadius={"40px"}
                  p={"15px"}
                  border={"1px solid #EB1C47"}
                  mt={"50px"}
                  w={["90%", "90%", "40%", "40%"]}
                >
                  <Text
                    textAlign={"center"}
                    color={"#fff"}
                    fontFamily={"nunito"}
                  >
                    Mmanwu volume 2 coming soon
                  </Text>
                </Box>
              </Box>
            )}
          </Box>
        </>
      )}
    </Box>
  );
}

export default App;
